

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastError } from "../../../Helper/ToastMessage";

// Get Table Data
export const PinjaraGadiTrackGetTableDataAPI = createAsyncThunk("PinjaraGadiTrackGetTableData", async ({ data }) => {
    const {
        M_ZoneID,
        M_VehicleID,     
        Language,
        M_UserID,
        FromTop,
        ToTop,
        token,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_M_PinjaraGadi_Track_Select?M_ZoneID=${M_ZoneID}&M_VehicleID=${M_VehicleID}&Language=${Language}&M_UserID=${M_UserID}&FromTop=${FromTop}&ToTop=${ToTop}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data && result.data.table) {
                    return result.data.table
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                return result
            }
        })
})

const PinjaraGadiTrackGetTableDataSlice = createSlice({
    name: "PinjaraGadiTrackGetTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PinjaraGadiTrackGetTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PinjaraGadiTrackGetTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(PinjaraGadiTrackGetTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const PinjaraGadiTrackGetTableDataReducer = PinjaraGadiTrackGetTableDataSlice.reducer

